<template>
  <div
    class="group relative flex aspect-[6/7] overflow-hidden p-6 pt-10 xs:aspect-[4/3] sm:px-8 sm:pb-8"
    :class="entry.image ? 'text-beige-500' : 'bg-white'"
  >
    <!-- IMAGE -->
    <AppImage
      v-if="entry.image"
      loading="lazy"
      class="absolute inset-0 object-cover duration-500 ease-in-out group-hover:scale-105"
      :src="entry.image"
    />

    <!-- TEXT -->
    <div class="relative z-10 flex grow flex-col justify-between text-left">
      <!-- Date -->
      <h3 class="uppercase typo-subtitle-md">{{ hero.sub_heading }}</h3>

      <!-- Title & Link -->
      <AppLink
        class="z-10 after:absolute after:inset-0 after:z-20"
        :to="entry.url"
        :aria-label="entry.title"
      >
        <span
          class="text-blu flex w-full items-end justify-between gap-4"
          :class="entry.image ? 'text-beige-500' : 'text-gray-500'"
        >
          <span
            class="line-clamp-5 hyphens-auto text-left typo-heading-xs md:line-clamp-4 lg:line-clamp-5"
          >
            {{ entry.title }}
          </span>
          <IconArrowRight
            class="size-5 shrink-0 self-end transition-[opacity,transform] duration-500 group-hover:translate-x-3 sm:size-5"
          />
        </span>
      </AppLink>
    </div>

    <!-- GRADIENT -->
    <div
      class="pointer-events-none absolute inset-0"
      :class="entry.image ? 'gradient-image' : 'gradient group-hover:scale-125'"
    />

    <!-- GRADIENT HOVER -->
    <div
      class="pointer-events-none absolute inset-0 m-[-5%] origin-bottom scale-y-0 opacity-0 blur-lg transition-[opacity,transform] duration-500 ease-in-out group-hover:scale-y-100 group-hover:opacity-100"
      :class="entry.image ? 'gradient-image-hover' : 'gradient-hover '"
    />
  </div>
</template>

<script setup lang="ts">
import type { AssetFragment } from '#gql'

const props = defineProps<{
  entry: {
    id: string
    title: string
    url: string
    image: AssetFragment
    replicator_heros: any
  }
}>()

const hero = computed(() => {
  if (!props.entry?.replicator_heros) {
    return null
  }
  return props.entry?.replicator_heros[0]
})
</script>

<style scoped lang="scss">
.gradient {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 33%,
    rgba(148, 162, 197, 0.4) 100%
  );
}
.gradient-hover {
  background: linear-gradient(
    180deg,
    rgba(10, 54, 169, 0) 0%,
    rgba(10, 54, 169, 0.3) 100%
  );
}
.gradient-image {
  background: linear-gradient(
    180deg,
    rgba(48, 61, 92, 0.5) 50%,
    rgba(48, 61, 92, 0.8) 100%
  );
}
.gradient-image-hover {
  background: linear-gradient(
    180deg,
    rgba(10, 54, 169, 0.3) 20%,
    rgba(10, 54, 169, 1) 100%
  );
}
</style>
